import React from 'react';

const HTMLPreview = ({ description, files = [], endpoint = '' }) => {
    // Process description to replace file references with actual URLs
    const processDescription = (desc, files) => {
        if (!desc || !files) return desc;
        
        let processedDesc = desc;
        
        files.forEach(file => {
            const filePattern = new RegExp(`/${endpoint}/files/${file.filename}`, 'g');
            processedDesc = processedDesc.replace(
                filePattern,
                `${process.env.REACT_APP_API_URL || '/api'}/${endpoint}/files/${file.filename}`
            );
        });
        
        return processedDesc;
    };

    const processedContent = processDescription(description, files);

    return (
        <div 
            dangerouslySetInnerHTML={{ 
                __html: processedContent 
            }} 
        />
    );
};

export default HTMLPreview;
